import React, { useState, useEffect } from "react";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import "./Bidcom.css";
import Enoughamount from "./Enoughamount";
const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:focus": {
      outline: "none",
    },
  },

  paper: {
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    border: "none",

    flexDirection: "column",
    alignItems: "center",
    boxShadow: theme.shadows[5],

    "&:focus": {
      outline: "none",
    },

    position: "relative",
    borderRadius: "10px",
  },
}));
const Bidcom = ({
  bidvalue,
  color,
  paritytype,
  period,
  setOpen,
  bidhistoryfast,
  bidhistoryparity,
}) => {
  const classes = useStyles();
  const [amount, setamount] = useState("5");
  const [checkamount, setcheckamount] = useState(true);
  const [userdata, setuserdata] = useState("");
  const [open, setopen] = useState(false);

  const handleOpen = () => {
    setopen(true);
  };

  const handleClose = () => {
    setopen(false);
  };
  axios.defaults.headers.post["Authorization"] = `Bearer ${localStorage.getItem(
    "tokenAuth"
  )}`;
  axios.defaults.headers.get["Authorization"] = `Bearer ${localStorage.getItem(
    "tokenAuth"
  )}`;
  const userinfo = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/user`,
      {
        selectedBid: bidvalue,
      }
    );

    console.log("user info", response.data.data.wallet_amount);
    setuserdata(response.data.data.wallet_amount);
  };

  useEffect(() => {
    userinfo();
  }, []);

  const playgame = async () => {
    if (userdata === 0) {
      handleOpen();
    } else {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/playGame`,
        {
          period: period,
          type: paritytype,
          selectedBid: bidvalue,
          amount: amount,
        }
      );

      if (response) {
        setOpen(false);
        if (paritytype === "fastparity") {
          bidhistoryfast();
        } else {
          bidhistoryparity();
        }
      }
      console.log("your bid ", response);
    }
  };
  const addd = () => {
    let num = parseInt(amount);
    setamount(num + 5);
  };
  const min = () => {
    let num = parseInt(amount);
    setamount(num - 5);
  };
  const addd1 = () => {
    let num = parseInt(amount);
    setamount(num + 1);
  };
  const min1 = () => {
    let num = parseInt(amount);
    setamount(num - 1);
  };

  return (
    <>
      <div>
        <Modal
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              <Enoughamount setopen={setopen} />
            </div>
          </Fade>
        </Modal>
      </div>
      <div className="main-choice-div-recharge10">
        <div className="choice-hd">
          <h2>
            Parity-<span style={{ color: color }}>{bidvalue}</span>
          </h2>
        </div>
        <div className="recharge-choice-div-point1">
          <div className="recharge-choice-div-point-inner">
            <p>Point</p>
            <input type="text" placeholder="₹9.730" />
          </div>
          <button>Recharge</button>
        </div>
        <p className="contract-p">Contract Point</p>
        <div className="flex-div-choice">
          <div
            onClick={() => setamount("20")}
            className={amount === "20" ? "div-circle-black1" : "div-circle1"}
          >
            ₹20
          </div>
          <div
            onClick={() => setamount("100")}
            className={amount === "100" ? "div-circle-black1" : "div-circle1"}
          >
            ₹100
          </div>
          <div
            onClick={() => setamount("1000")}
            className={amount === "1000" ? "div-circle-black1" : "div-circle1"}
          >
            ₹1000
          </div>
          <div
            onClick={() => setamount("10000")}
            className={amount === "10000" ? "div-circle-black1" : "div-circle1"}
          >
            ₹10000
          </div>
        </div>
        <p className="contract-p">Number</p>

        <div>
          <div className="add-div1">
            <button onClick={min}>-5</button>
            <button onClick={min1}>-1</button>
            <span className="red-amount">{amount}</span>

            <button onClick={addd}>+5</button>
            <button onClick={addd1}>+1</button>
          </div>
        </div>
        <div className="left-deliver-div">
          <div className="left-deliver-div-inear">
            <div className="left-deliver-div-inear-p">
              <p >Delivery:</p>
              <p>Fee:</p>
              <p>Amount:</p>
            </div>
            <div className="left-deliver-div-inear-p">
              <p dir="rtl">47.50</p>
              <p dir="rtl">2.50</p>
              <p dir="rtl">+166.25</p>
            </div>
          </div>
        </div>
        <div onClick={playgame} className="comfirm-btns">
          <button>Confirm</button>
        </div>
      </div>
    </>
  );
};

export default Bidcom;
